export const TRACK_REACTIONS = Object.freeze([
  { id: 'up', emoji: '👍', label: 'Thumbs up' },
  { id: 'love', emoji: '❤️', label: 'Love' },
  { id: 'down', emoji: '👎', label: 'Thumbs down' },
]);

export const TRACK_REACTION_IDS = TRACK_REACTIONS.map((item) => item.id);

export function isTrackReactionType(value) {
  return TRACK_REACTION_IDS.includes(value);
}

/** Commit a reaction type. Same type stays committed; never clears. */
export function nextTrackReaction(currentType, tappedType) {
  if (!isTrackReactionType(tappedType)) return currentType || null;
  return tappedType;
}

/**
 * Strongest occurrence identity already on the queue/player item.
 * Never uses display title.
 */
export function trackOccurrenceKey(track) {
  if (!track || typeof track !== 'object') return null;
  if (typeof track.queueItemId === 'string' && track.queueItemId.trim()) {
    return track.queueItemId.trim();
  }
  const videoId = track.videoId || track.id;
  if (!videoId) return null;
  const addedBy = track.addedBy || 'anon';
  const addedAt = track.addedAt || '';
  return `${videoId}::${addedBy}::${addedAt}`;
}

export function reactionScopeKey({ context = 'event', contextId, userId }) {
  if (!contextId || !userId) return null;
  return `${context}:${contextId}:${userId}`;
}

export function buildReactionRecord({
  type,
  track,
  context = 'event',
  contextId,
  userId,
  live = false,
  updatedAt = Date.now(),
}) {
  if (!isTrackReactionType(type)) return null;
  const occurrenceKey = trackOccurrenceKey(track);
  if (!occurrenceKey || !contextId || !userId) return null;
  const videoId = track.videoId || track.id || null;
  return {
    type,
    context,
    contextId,
    userId,
    occurrenceKey,
    videoId,
    providerAssetKey: track.providerAssetKey || null,
    recordingId: typeof track.recordingId === 'string' && track.recordingId
      ? track.recordingId
      : null,
    live: Boolean(live),
    updatedAt,
  };
}
